import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, ENVIRONMENT, TokenService } from '@cfp/core';
import { LoginCard, LoginLayout } from '@cfp/shared/ui/login';
import { LoadingSpinner } from '@cfp/ui/common';
import { TranslateModule } from '@ngx-translate/core';
import { LoginTokenDTO, SamlLoginService } from 'csr-login-app';
import { FooterText } from '../../components';

@Component({
  selector: 'cfp-sso-authentication-page',
  templateUrl: './sso-authentication-page.html',
  imports: [LoginLayout, LoginCard, LoadingSpinner, TranslateModule, FooterText]
})
export class SsoAuthenticationPage implements OnInit {
  protected loading: boolean = true;
  protected errorMessage: string;

  protected readonly environment = inject(ENVIRONMENT);
  private readonly samlLoginService = inject(SamlLoginService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly tokenService = inject(TokenService);

  public ngOnInit(): void {
    this.samlLoginService.samltokenloginPost({ environmentCode: this.environment.environmentCode.dto }).subscribe({
      next: (response: LoginTokenDTO) => {
        // todo: needs tobe refactored to accessToken only there are some backend issues why we cannot yet change
        this.tokenService.setToken(response['access_token']);
        this.authService.goToApp();
      },
      error: (error) => {
        this.loading = false;
        if (error?.error?.code === 'MISSING_GROUP') {
          this.errorMessage = 'error.sso.couldNotLoginMissingGroup';
        } else {
          this.errorMessage = 'error.sso.couldNotLogin';
        }
      }
    });
  }

  protected closeWindow(): void {
    if (window.opener) {
      window.close();
    } else {
      this.router.navigateByUrl(this.environment.loginRoute);
    }
  }
}
